export class ProvisionResult {
    constructor() {
        this.error = null;
        this.apiData = {};
        this.loaded = false;
    }
}